import { gql } from "@apollo/client";
import {
  CustomerNoNestingFragment,
  LocationNoNestingFragment,
  PaymentNoNestingFragment,
  ProductNoNestingFragment,
  SaleAdjustmentNoNestingFragment,
  SaleFragment,
  SaleLineItemNoNestingFragment,
  StaffNoNestingFragment,
  TerminalNoNestingFragment,
} from "@towersystems/roam-common/lib/generated-graphql-fragment";

export const GIFTCARD_PRODUCT_SKU = "GIFTCARD";

export const QUERY_GIFT_CARD_BY_CODE = gql`
  query GiftCardByCode($code: String!) {
    giftCardByCode(code: $code) {
      id
      code
      balance
      currency
      expiryDate
      canBeRedeemed
    }
  }
`;

export const QUERY_GIFT_CARD_TRANSACTIONS_BY_CODE = gql`
  query GiftCardTransactionsByCode($giftCode: String!) {
    giftCardTransactionsByCode(giftCode: $giftCode) {
      id
      transactionType
      giftCardId
      amount
      currency
      transactionDate
    }
  }
`;

// this needs to be changed once the api is updated
export const MUTATION_REDEEM_GIFT_CARD = gql`
  ${SaleFragment}
  ${PaymentNoNestingFragment}
  ${SaleLineItemNoNestingFragment}
  ${LocationNoNestingFragment}
  ${CustomerNoNestingFragment}
  ${SaleAdjustmentNoNestingFragment}
  ${TerminalNoNestingFragment}
  ${StaffNoNestingFragment}
  mutation RedeemGiftCard($input: RedeemGiftCardInput!) {
    redeemGiftCard(input: $input) {
      ...Sale
      isReturn
      returnForId
      lineItems {
        ...SaleLineItemNoNesting
        adjustments {
          ...SaleAdjustmentNoNesting
        }
      }
    }
  }
`;

export const MUTATION_ACTIVATE_SALE_GIFT_CARDS = gql`
  ${SaleFragment}
  ${SaleLineItemNoNestingFragment}
  ${PaymentNoNestingFragment}
  ${LocationNoNestingFragment}
  ${ProductNoNestingFragment}
  ${CustomerNoNestingFragment}
  ${SaleAdjustmentNoNestingFragment}
  ${TerminalNoNestingFragment}
  ${StaffNoNestingFragment}
  mutation ActivateSaleGiftCards($saleId: ID!) {
    activateSaleGiftCards(saleId: $saleId) {
      ...Sale
      isReturn
      returnForId
      location {
        name
      }
      customer {
        ...CustomerNoNesting
      }
      lineItems {
        ...SaleLineItemNoNesting
        product {
          ...ProductNoNesting
          image {
            path
          }
        }
        adjustments {
          ...SaleAdjustmentNoNesting
        }
      }
    }
  }
`;

export const MUTATION_GENERATE_INACTIVE_GIFT_CARD = gql`
  mutation GenerateInactiveGiftCard {
    generateGiftCard {
      id
      code
      balance
      currency
      expiryDate
      canBeRedeemed
    }
  }
`;
